import React, { useState } from "react";

const RazorpayPayment = () => {
  const [loading, setLoading] = useState(false);

  const handlePayment = async () => {
    try {
      setLoading(true);

      // 1️⃣ Call backend to create order
      const response = await fetch("https://landnest.net:81/create-payment/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        // amount is fixed (200 INR)
        body: JSON.stringify({ amount: 200 }),
      });

      const orderData = await response.json();
      if (!orderData.status) {
        alert("Failed to create order");
        setLoading(false);
        return;
      }

      // 2️⃣ Configure Razorpay Checkout
      const options = {
        key: orderData.key, // from backend
        amount: orderData.amount, // in paise
        currency: orderData.currency,
        name: "My Shop",
        description: "Test Transaction",
        order_id: orderData.order_id,
        handler: async function (response) {
          // 3️⃣ Send payment details to backend for verification
          const verifyRes = await fetch("https://landnest.net:81/verify-payment/", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(response),
          });

          const verifyData = await verifyRes.json();
          if (verifyData.status) {
            alert("✅ Payment successful!");
          } else {
            alert("❌ Payment verification failed!");
          }
        },
        theme: {
          color: "#3399cc",
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
      setLoading(false);
    } catch (error) {
      console.error("Error:", error);
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h2 className="text-xl font-bold mb-4">Pay 200 INR</h2>
      <button
        onClick={handlePayment}
        disabled={loading}
        className="px-6 py-2 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 disabled:opacity-50"
      >
        {loading ? "Processing..." : "Pay Now"}
      </button>
    </div>
  );
};

export default RazorpayPayment;